import firebase from 'firebase'

export const SELECT_ACTIVITY = 'assessments/SELECT_ACTIVITY'
export const INVALIDATE_ACTIVITY = 'assessments/INVALIDATE_ACTIVITY'

function loadCps(activity) {
  return {
    type: SELECT_ACTIVITY,
    activity
  }
}


function getDimensionRef(parentId, cpId,dimensionId) {
  const {assessmentId, activityId } = parentId
  return firebase.firestore().collection('assessmentsByRater').doc(assessmentId)
      .collection('answers').doc(activityId)
      .collection('competencies').doc(cpId)
      .collection('dimensions').doc(dimensionId)
}

function getAnswersRef(assessmentId,activityId) {
  return firebase.firestore()
    .collection('assessmentsByRater').doc(assessmentId)
    .collection('answers').doc(activityId)
    .collection('competencies')
  }


function asObject(cps) {
    return cps.reduce( (acc,cp) => { acc[cp.id] = cp.data(); return acc} ,{} )
}

function asArray(cps) {
    return cps.map(cp => { 
        const data = cp.data()
        const { name, description, levels } = data
        return { id: cp.id, name, description, levels }
        } )
}

export function selectActivity(activity) {
  return (dispatch) => {
 
    const promises = activity.data.competencies.map(cp => cp.get() )
    Promise.all(promises).then(cps => {
      dispatch( loadCps({id: activity.id, company:activity.data.company, competencies: cps,
            cps: asObject(cps), cpsArray: asArray(cps)} )  )
    })

  }
}


export function invalidateActivity(breadcrumbs) { 
  return {
    type: INVALIDATE_ACTIVITY,
    breadcrumbs
  }
}



export const UPDATE_ANSWER = 'assessments/UPDATE_ANSWER'
export const GET_ANSWER = 'GET_ANSWER'

/**
 * Selector
 * @param {*} cpId 
 * @param {*} dimensionId 
 */
export function formatId(cpId,dimensionId) {
    return cpId + '/' + dimensionId
}

export function getAnswer(parentId, cpId,dimensionId) {
    return (dispatch, getState) => {
        getDimensionRef(parentId, cpId,dimensionId)
            .get().then(doc => {
                dispatch({type: GET_ANSWER, id: formatId(cpId,dimensionId), answer: doc.data() })
            })
    }
}

export function updateAnswer(parentId, cpId,dimensionId,indicatorId,store) {
              //let answers = selectedAssessment.answers
            //console.log(selectedAnswers)
    return (dispatch, getState) => {
        dispatch({type: GET_ANSWER, id: formatId(cpId, dimensionId), answer: { indicatorId } })
        getDimensionRef(parentId, cpId,dimensionId)
                .set( {indicatorId })
                .then(() => { 
                    //dispatch({type: 'ERROR', id: dimensionId ,message: 'error' })
                    console.log('Document successfully written')
                     })
                .catch(error => {
                    dispatch({type: 'ERROR', id: formatId(cpId,dimensionId) ,message: error })
                })

            /*
            ,
            subcollections: [{ collection: 'dimensions', doc: dimensionId,
                subcollections: [{ collection: 'indicators', doc: indicatorId}]
            }]
            
            store.firestore.add({ collection:'assessmentsByRater', doc: assessment.id, 
                subcollections: [ { collection: 'answers'
                }] },{text: 'new', selected: true})
                .then(data => {  
                    console.log(data)
                    return data })
                .catch(error => {
                    console.log(error)
                })
                */
            /*
            
            store.firestore.update({ collection:'assessmentsByRater', doc: assessment.id },{answers: answers})
                .then(data => {  
                    assessment.answers = answers
                    dispatch({type: UPDATE_ANSWER,assessment})
                    return data })
                .catch(error => {
                    dispatch({type: 'ERROR', levelId: levelId ,message: error })
                })

                */
                
    }
}


// WEBPACK FOOTER //
// ./src/activities/actions.js